import { cn } from '../lib/utils';
import { usePortfolioPrefsStore } from '../store';

/**
 * GBP / EUR display-currency toggle.
 *
 * Reads and writes the portfolio-scope displayCurrency preference from the
 * shared Zustand store so the choice persists across Dashboard, P&L, Revenue,
 * and Costs pages.
 */
export function CurrencyToggle({ className }) {
  const displayCurrency = usePortfolioPrefsStore((s) => s.displayCurrency);
  const setDisplayCurrency = usePortfolioPrefsStore((s) => s.setDisplayCurrency);

  return (
    <div className={cn('flex gap-0.5 bg-muted rounded-md p-0.5', className)}>
      {['GBP', 'EUR'].map((c) => (
        <button
          key={c}
          className={cn(
            'px-2.5 py-1 text-xs font-semibold rounded transition-all',
            displayCurrency === c
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          )}
          onClick={() => setDisplayCurrency(c)}
        >
          {c === 'GBP' ? '\u00A3 GBP' : '\u20AC EUR'}
        </button>
      ))}
    </div>
  );
}
